import { useUserStore } from '../stores/userStore';

// Modern, colorful avatar illustration with initials
const generateInitialsAvatar = (name: string = 'U') => {
  const initial = name.charAt(0).toUpperCase();
  return `data:image/svg+xml,${encodeURIComponent(`
    <svg width="40" height="40" viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg">
      <defs>
        <linearGradient id="gradient" x1="0%" y1="0%" x2="100%" y2="100%">
          <stop offset="0%" style="stop-color:#6366F1" />
          <stop offset="100%" style="stop-color:#A855F7" />
        </linearGradient>
      </defs>
      <rect width="40" height="40" rx="20" fill="url(#gradient)" />
      <text x="50%" y="50%" text-anchor="middle" dy="0.35em" fill="white" font-family="system-ui" font-size="20" font-weight="bold">
        ${initial}
      </text>
    </svg>
  `)}`;
};

export const getProfilePicture = (userId: string): string => {
  const { users } = useUserStore.getState();
  const user = Object.values(users).find(u => u.id === userId);
  
  if (user?.photo) {
    return user.photo;
  }

  return generateInitialsAvatar(user?.fullName);
};